import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { SourcesTab } from '../../components/RegulatoryWatchAdmin/SourcesTab';

export const AdminSourcesPage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <SourcesTab />
    </FlexCol>
  );
};
